export default __webpack_public_path__ + "90af8613f1a597a12e942e44968a76cd.png";